<template>
    <div>
        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Domain Contacts</template>

            <!-- Data -->
            <template slot="data">
                <div class="row">
                    <div class="col">
                        <h3>
                            Contacts
                            <span
                                class="sau-font sm"
                                v-if="!canUpdateDomain"
                            >- Updating contacts is only available with active domains</span>
                        </h3>

                        <!-- show error if no contacts are retrieved -->
                        <div v-if="Object.keys(contacts).length == 0">
                            <sau-apiro-response type="error" support="true">
                                <template
                                    slot="message"
                                >We were unable to retrieve contacts for this domain.</template>
                                <template slot="details">
                                    <div v-if="locked">
                                        <p>The following response has been provided by the registrar:</p>
                                        <p class="alert alert-warning">{{ locked }}</p>
                                    </div>

                                    <p>If you would like further details please contact our Support Team.</p>
                                </template>
                            </sau-apiro-response>
                        </div>

                        <div class="sau-bx bx-pad" v-else-if="!locked && canUpdateDomain">
                            <form>
                                <div v-for="(contact, key) in contacts" :key="key" class="pb-6">
                                    <h3>{{ key }} Contact</h3>
                                    <div class="row">
                                        <div class="col">
                                            <div class="sau-bx bx-pad">
                                                <div class="row">
                                                    <template v-for="(f_value, f_key) in contact">
                                                        <div
                                                            class="col-lg-6"
                                                            v-if="f_key != 'ContactID'"
                                                            :key="f_key"
                                                        >
                                                            <div class="form-group">
                                                                <label
                                                                    :for="key + '-' + f_key"
                                                                >{{ formatLabel(f_key) }}</label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    :id="key + '-' + f_key"
                                                                    v-model="contacts[key][f_key]"
                                                                >
                                                                <!-- empty div so the form layout is consistent across the site -->
                                                                <div>&nbsp;</div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="float-right pt-4">
                                            <a :href="domainDetailsLink">Cancel</a>
                                            <button
                                                href="#"
                                                @click.prevent="updateContacts()"
                                                class="btn ml-4 btn-success"
                                                :disabled="submitting"
                                            >
                                                Update
                                                <i
                                                    v-if="submitting"
                                                    class="far fa-spinner-third fa-spin"
                                                ></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div v-else-if="!canUpdateDomain" class="sau-bx bx-pad">
                            <div v-for="(contact, key) in contacts" :key="key" class="pb-6">
                                <h3>{{ key }} Contact</h3>
                                <div class="row">
                                    <div class="col">
                                        <div class="sau-bx bx-pad">
                                            <div class="row">
                                                <template v-for="(f_value, f_key) in contact">
                                                    <div
                                                        v-if="f_key != 'ContactID'"
                                                        class="col-sm-12 col-md-6 sau-readonly-display"
                                                        :key="f_key"
                                                    >
                                                        <h5>{{ formatLabel(f_key) }}</h5>
                                                        <p>{{ contacts[key][f_key] || 'Not Set' }}</p>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-else>
                            <div class="col">
                                <sau-apiro-response type="message">
                                    <template slot="message">Unable to update contacts.</template>
                                    <template slot="details">
                                        <p>{{ locked }}</p>
                                    </template>
                                </sau-apiro-response>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
export default {
    props: ['domain'],
    data() {
        return {
            submitting: false,
            contacts: '',
            display: false,
            form: {},
            locked: false
        };
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getDomainContacts()
                .then(response => {
                    if (response.data.contacts) {
                        if (response.data.contacts.data) {
                            this.locked = response.data.contacts.data.error;
                        } else {
                            // Filter out na response
                            this.contacts = response.data.contacts.na
                                ? ''
                                : response.data.contacts;
                        }
                    }
                })
                .catch(error => {});
        },
        formatLabel(label) {
            // Match uppercase, lowercase and optional number at the end (for address 2 etc)
            return label.match(/([A-Z][a-z]*)?([0-9])?/g).join(' ');
        },
        updateContacts() {
            this.submitting = true;
            this.updateDomainContacts(this.contacts)
                .then(response => {
                    if (response.data.result == 'success') {
                        this.$swal({
                            type: 'success',
                            title: 'Contacts Updated',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        this.$swal({
                            type: 'error',
                            title: 'Something went wrong',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    }
                    this.submitting = false;
                })
                .catch(error => {
                    this.$swal({
                        type: 'error',
                        title: 'Something went wrong',
                        html: error.response.data,
                        showConfirmButton: true,
                        confirmButtonClass: 'btn btn-danger',
                        buttonsStyling: false
                    });
                    this.submitting = false;
                });
        }
    }
};
</script>
<style>
.sau-readonly-display {
    padding-top: 10px;
    margin: 0;
}
.sau-readonly-display p {
    padding-bottom: 10px;
    margin: 0;
    border-bottom: 1px solid #e5e5e5;
}
.sau-readonly-display:nth-last-child(-n + 2) p {
    border: 0;
}
.sau-readonly-display h5 {
    margin: 0;
    padding: 0;
}
</style>
